import { render, staticRenderFns } from "./PatientProfileConfirm.vue?vue&type=template&id=3bd437c2&scoped=true&"
import script from "./PatientProfileConfirm.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PatientProfileConfirm.vue?vue&type=style&index=0&id=3bd437c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd437c2",
  null
  
)

export default component.exports